<template>
  <button @click="downloadPDF()" class="btn btn-sm btn-info" v-tooltip="$t('tooltip.downloadLeagueDocx')"> <i v-if="!loading" class="fa fa-file-word-o"></i> <i v-if="loading" class="fa fa-spinner fa-spin"></i></button>
</template>

<script>
import ExportService from '../../services/export.service'

export default {
  name: 'DocxDownload',
  props: {
    schedule: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    downloadPDF () {
      this.loading = true
      ExportService.leagueScheduleWord(this.schedule.uuid).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', `${this.filename}.docx`)
        document.body.appendChild(fileLink)
        fileLink.click()
      }).finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    filename () {
      return this.schedule.name + ' - ' + this.$d(new Date(), 'dateLong')
    }
  }
}
</script>
